import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

export const firebaseConfig = {
  apiKey: "AIzaSyA2X0tFB28LBWHiZjePovyoLqzt5X0u4wA",
  authDomain: "aslaaios.firebaseapp.com",
  projectId: "aslaaios",
  storageBucket: "aslaaios.firebasestorage.app",
  messagingSenderId: "365005048275",
  appId: "1:365005048275:web:6fe5aeb5631ad2ee460726",
  measurementId: "G-KMTH250C0P"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Setup Messaging
export const messaging = getMessaging(firebaseApp);

// Optionally export getToken if you need it elsewhere
export { getToken };